import React, { useEffect, useState } from 'react';
import { useSettings } from '../../contexts/SettingsContext';

const SettingsPage: React.FC = () => {
  const { settings, update, refresh } = useSettings();
  const [form, setForm] = useState({ systemName: '', logoUrl: '' });
  const [msg, setMsg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => {
    if (settings) setForm({ systemName: settings.systemName, logoUrl: settings.logoUrl });
  }, [settings]);

  const onSave = async (e: React.FormEvent) => {
    e.preventDefault(); setMsg(null); setErr(null);
    try { await update(form); setMsg('Settings saved'); }
    catch (e: any) { setErr(e?.response?.data?.error || 'Failed to save'); }
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-soft p-6">
        <h1 className="text-2xl font-bold mb-4">Settings</h1>
        {msg && <div className="mb-3 text-green-600 text-sm">{msg}</div>}
        {err && <div className="mb-3 text-red-600 text-sm">{err}</div>}
        <form onSubmit={onSave} className="space-y-4">
          <div>
            <label className="form-label">System Name</label>
            <input className="form-input" value={form.systemName} onChange={e => setForm({ ...form, systemName: e.target.value })} />
          </div>
          <div>
            <label className="form-label">Logo URL</label>
            <input className="form-input" value={form.logoUrl} onChange={e => setForm({ ...form, logoUrl: e.target.value })} />
            {form.logoUrl && (
              <div className="mt-2"><img src={form.logoUrl} alt="Logo preview" className="h-10" /></div>
            )}
          </div>
          <button className="btn-primary">Save</button>
        </form>
      </div>
    </div>
  );
};

export default SettingsPage;

